<ion-content class="garment-repair">
    <app-header [title]="(routeStopName ?? '') + ' (' + stopName + ') : Repair'" [breadcrumbs]="breadcrumbs"></app-header>
    <ng-container>
        <div class="loading-container" style="padding-top:10%" *ngIf="!loaded">
            <ion-spinner></ion-spinner>
        </div>
        <div class="content-container">
            <ion-row class="garment-row">
                <ion-col class="ion-no-padding" >
                    <ion-row style="margin-bottom:5px">
                        <ion-label>Garment Code</ion-label>
                    </ion-row>
                    <ion-row>
                        <ion-input placeholder="Enter Garment Code" [(ngModel)]="garmentCode"></ion-input>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="garment-row">
                <ion-col class="ion-no-padding">
                    <ion-row>
                        <ion-label>Reason</ion-label>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                        <ion-select placeholder="Select Reason" interface="popover"
                        [interfaceOptions]="{'cssClass': 'wider-popover'}" [(ngModel)]="messageCode" (ionChange)="onReasonChange()" >
                            <ion-select-option value="06">Relable Garment ID</ion-select-option>
                            <ion-select-option value="15">Repair - Belt Loop / Drawstring</ion-select-option>
                            <ion-select-option value="11">Repair - Buttons, Button Holes, Snaps</ion-select-option>
                            <ion-select-option value="13">Repair - Check All</ion-select-option>
                            <ion-select-option value="MSG0010064">Repair - Check Seat / Inner Thigh</ion-select-option>
                            <ion-select-option value="MSG0010031">Repair - Check Zipper</ion-select-option>
                            <ion-select-option value="21">Repair - Emblems</ion-select-option>
                            <ion-select-option value="14">Repair - Pockets</ion-select-option>
                            <ion-select-option value="12">Repair - Seams or Hems</ion-select-option>
                            <ion-select-option value="MSG0010070">Repair - Sleeve/Cuff</ion-select-option>
                            <ion-select-option value="MSG0010042">Repair - Tear</ion-select-option>
                            <ion-select-option value="MSG0010080">Replace - Inspect for Replacement</ion-select-option>
                            <ion-select-option value="05">Send to Customer Service</ion-select-option>
                            <ion-select-option value="MSG0010033">Verify - All Emblems</ion-select-option>
                            <ion-select-option value="MSG0010046">Verify - Name Emblem Spelling</ion-select-option>
                        </ion-select>
                        </ion-col>
                        <ion-col>
                      
                        </ion-col>
                    </ion-row>
                    <ion-row style="margin-top:10px;margin-bottom:5px">
                        <ion-label>Selected Reasons:</ion-label>
                      </ion-row>
                      
                      <ion-row *ngIf="selectedReasons.length > 0" style="width:100%">
                        <ion-col>

                          <ion-list style="background-color: #f0f0f0; padding: 10px; border-radius: 10px;">
                            <ion-item *ngFor="let reason of selectedReasons; let i = index">
                              {{ reason }}
                              <ion-button fill="clear" color="danger" (click)="removeReason(i)" style="width:50px;">
                                <ion-icon slot="icon-only" name="trash"></ion-icon>
                              </ion-button>
                            </ion-item>
                          </ion-list>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="selectedReasons.length === 0" style="width:100%; height: 100px; background-color: #f0f0f0; display: flex; justify-content: center; align-items: center; border-radius: 10px;">
                        <ion-col>
                          <div style="text-align: center; font-size: 16px; color: #888;">
                            No item Selected
                          </div>
                        </ion-col>
                      </ion-row>
                      
                </ion-col>
            </ion-row>

            <ion-row>
                <ion-button class="button"  style='margin-top:10px;--background: #006633;' (click)="PostMessage()">
                    Save Repairs
                </ion-button>
            </ion-row>
        </div>
    </ng-container>
</ion-content>